export { default } from "../../ipd/utils/IpdTabBar";
